import { render, staticRenderFns } from "./mediaPreviewPopover.vue?vue&type=template&id=0f11c60b&scoped=true&"
import script from "./mediaPreviewPopover.vue?vue&type=script&lang=js&"
export * from "./mediaPreviewPopover.vue?vue&type=script&lang=js&"
import style0 from "./mediaPreviewPopover.vue?vue&type=style&index=0&id=0f11c60b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f11c60b",
  null
  
)

export default component.exports